import React from 'react';
import apiFetch from '@wordpress/api-fetch';
import * as lodash from 'lodash';
import * as dateFns from 'date-fns';
import ja from 'date-fns/locale/ja';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

import {getTimeSectionAndMenuKind} from '../helper';
import Loading from './loading';
import CalcHeader from './calc-header';
import UserAttributes from './user-attributes';
import SelectProvide from './select-provide';
import CalcResult from './calc-result';
import CalcFooter from './calc-footer';

export default class NutritionCalc extends React.Component {

    constructor(props) {
        super(props);

        const saved_user_attributes = localStorage.getItem('user_attributes');
        const user_attributes = saved_user_attributes ? JSON.parse(saved_user_attributes) : {
            sex: 0,
            age: 0,
            life_activity_intensity: 0,
        };
        const saved_calc_histories = localStorage.getItem('calc_histories');
        const calc_histories = saved_calc_histories ? JSON.parse(saved_calc_histories) : [];

        const searchParams = new URLSearchParams(window.location.search);
        const provide_date = searchParams.get('provide_date') ?? '';
        const time_section = searchParams.get('time_section') ?? '';
        const is_date_select = provide_date !== '' && time_section !== '';

        this.state = {
            active_page: 0,
            is_date_select: is_date_select,
            is_one_serving: true,
            user_attributes: user_attributes,
            calc_histories: calc_histories,
            provide_date: provide_date,
            time_section: time_section,
            provide_list: {},
            is_not_provide: false,
            cafeteria_menu: [],
            select_cafeteria_menu: [],
            is_toast_show: false,
            toast_text: '',
        }
    }

    handleActivePageChange = async (new_value) => {
        if (this.state.active_page === 0 && (new_value === 1 || new_value === 2)) {
            localStorage.setItem('user_attributes', JSON.stringify(this.state.user_attributes));
        }
        this.setState({
            active_page: new_value,
        });
        if (new_value === 2) {
            this.fetchMenu(this.state.provide_date, this.state.time_section);
        }
    }

    handleSexChange = (new_value) => {
        this.setState((prev_state) => ({
            user_attributes: {
                ...prev_state.user_attributes,
                sex: new_value,
            }
        }));
    }

    handleAgeChange = (new_value) => {
        this.setState((prev_state) => ({
            user_attributes: {
                ...prev_state.user_attributes,
                age: new_value,
            }
        }));
    }

    handleLifeActivityIntensityChange = (new_value) => {
        this.setState((prev_state) => ({
            user_attributes: {
                ...prev_state.user_attributes,
                life_activity_intensity: new_value,
            }
        }));
    }

    handleSelectProvideChange = (provide_date, time_section) => {
        this.setState({
            provide_date: provide_date,
            time_section: time_section,
        });
    }

    handleSelectMenuChange = (id, selected) => {
        const select_cafeteria_menu = this.state.cafeteria_menu.filter((item) => {
            if (item.id === id) {
                return selected ? true : false;
            } else {
                const selected_menu = this.state.select_cafeteria_menu.find(item2 => item2.id === item.id);
                if (selected_menu) {
                    return true;
                }
            }
            return false;
        });
        this.setState({
            select_cafeteria_menu: select_cafeteria_menu,
        });
    }

    handleOneServingChange = (new_value) => {
        this.setState({
            is_one_serving: new_value,
        });
    }

    handleToastShow = (text_value) => {
        this.setState({
            is_toast_show: true,
            toast_text: text_value,
        });

        setTimeout(() => {
            this.setState({
                is_toast_show: false,
            });
        }, 2000);
    }

    fetchProvide = async () => {
        let provide_date = dateFns.format(new Date(), 'yyyyMMdd');
        const provide_list_path = '/wp-json/cafeteria_api/provide_list?provide_date=' + provide_date;
        const provide_list = await apiFetch({
            path: provide_list_path
        });
        if (!Array.isArray(provide_list.provide_list)) {
            this.setState({
                provide_list: provide_list.provide_list,
            });
        } else {
            this.setState({
                is_not_provide: true,
            });
        }
    }

    // 食堂メニューの取得
    fetchMenu = async (provide_date, time_section) => {
        const cafeteria_menu_path = '/wp-json/wp/v2/cafeteria_menu?per_page=100&page=1&provide_date=' + provide_date + '&time_section=' + time_section;
        const menu = await apiFetch({
            path: cafeteria_menu_path,
            parse: false,
        });
        const menu_data = await menu.json();
        this.setState({
            cafeteria_menu: menu_data,
        });
    }

    async componentDidMount() {
        // 初期処理
        window.scrollTo(0, 0);
        this.fetchProvide();
    }

    render() {
        let next_disabled = false;
        if (this.state.active_page === 0) {
            if (this.state.user_attributes.sex === 0 || this.state.user_attributes.age === 0 || this.state.user_attributes.life_activity_intensity === 0) {
                next_disabled = true;
            }
        }
        if (this.state.active_page === 1) {
            if (this.state.provide_date === '' || this.state.time_section === '') {
                next_disabled = true;
            }
        }
        return (
            <React.Fragment>
                <div className="main-contents">
                    <CalcHeader active_page={this.state.active_page} is_date_select={this.state.is_date_select}/>
                    {
                        this.state.active_page === 0 &&
                        <UserAttributes
                            user_attributes={this.state.user_attributes}
                            onSexChange={this.handleSexChange}
                            onAgeChange={this.handleAgeChange}
                            onLifeActivityIntensityChange={this.handleLifeActivityIntensityChange}
                        />
                    }
                    {
                        this.state.active_page === 1 &&
                        <SelectProvide
                            provide_date={this.state.provide_date}
                            time_section={this.state.time_section}
                            provide_list={this.state.provide_list}
                            is_not_provide={this.state.is_not_provide}
                            onSelectProvideChange={this.handleSelectProvideChange}
                        />
                    }
                    {
                        this.state.active_page === 2 &&
                        <CalcResult
                            is_one_serving={this.state.is_one_serving}
                            user_attributes={this.state.user_attributes}
                            cafeteria_menu={this.state.cafeteria_menu}
                            select_cafeteria_menu={this.state.select_cafeteria_menu}
                            provide_name={this.state.provide_list[`${this.state.provide_date}_${this.state.time_section}`] ?? ''}
                            onSelectMenuChange={this.handleSelectMenuChange}
                            onOneServingChange={this.handleOneServingChange}
                            onToastShow={this.handleToastShow}
                        />
                    }
                    <CalcFooter next_disabled={next_disabled} active_page={this.state.active_page} is_date_select={this.state.is_date_select} onActivePageChange={this.handleActivePageChange}/>
                    <div className={`toast ${this.state.is_toast_show ? 'visible' : ''}`}>{this.state.toast_text}</div>
                </div>
            </React.Fragment>
        );
    }
}